export const API_HOST = (process.env.REACT_APP_API_HOST || "http://localhost:5283").replace(/\/$/, "");
export const API_BASE = `${API_HOST}/api`;
export const PUBLIC_SITE_URL = (process.env.REACT_APP_PUBLIC_SITE_URL || "https://i-law.vn").replace(/\/$/, "");
